import {
  FREE_TRACKERS,
  MINIMUM_FREE_TRACKER_LIMIT,
} from '../../../utils/constants';

// Determines if a user can add a new tracker record based on their subscription status,
// the number of existing records, and the type of tracker.
export function canAddTrackerRecord(
  isSubscribedToPaidStickers: boolean,
  recordsCount: number,
  trackerType: string
): boolean {
  // if user is subscribed -> always allowed
  if (isSubscribedToPaidStickers) {
    return true;
  }

  // if tracker is free -> always allowed
  if (FREE_TRACKERS.includes(trackerType)) {
    return true;
  }

  // if record count below free limit -> still allowed
  if (recordsCount < MINIMUM_FREE_TRACKER_LIMIT) {
    return true;
  }

  // otherwise -> not allowed (paid limit reached)
  return false;
}
